<ion-item [button]="button" [detail]="detail" [lines]="lines" [ngClass]="hostClassString">
  <ng-content></ng-content>
</ion-item>
